import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";


import SwitchButton from "src/components/switchButton";
import { createActivityPoint, disableActivityPoint, fetchGamificationPointTriggers } from "src/redux/actions/coaching/gamification";

import _ from "lodash";
import styles from "./points.module.scss";

const GamificationPointsTab: React.FC<object> = () => {
  const dispatch = useDispatch();
  const [landingOnExplorePointsOn, setLandingOnExplorePointsOn] = useState(false);
  const [onCompletePointsOn, setOnCompletePointsOn] = useState(false);

  const pointTriggers = useSelector((state: any) => {
    return _.get(state, "coaching.gamification.pointTriggers.items", []);
  });


  const handleToggleForExplorePoints = () => {
    if(landingOnExplorePointsOn) {
      const pointTrigger = pointTriggers.find((pointTrigger: any) => pointTrigger.name === "LOGIN");
      if(pointTrigger) {
        dispatch(disableActivityPoint({ id: pointTrigger.id }));
      }
    } else {
      dispatch(createActivityPoint({ name: "LOGIN", points: 10, triggerType: "LOGIN" }));
    }
    setLandingOnExplorePointsOn((v) => !v);
  };

  const handleToggleForOnCompletePoints = () => {
    if(onCompletePointsOn) {
      const pointTrigger = pointTriggers.find((pointTrigger: any) => pointTrigger.name === "LEARNING_COMPLETION");
      if(pointTrigger) {
        dispatch(disableActivityPoint({ id: pointTrigger.id }));
      }
    } else {
      dispatch(createActivityPoint({ name: "LEARNING_COMPLETION", points: 20, triggerType: "LEARNING_COMPLETION" }));
    }
    setOnCompletePointsOn((v) => !v);
  };

  useEffect(() => {
    dispatch(fetchGamificationPointTriggers());
  }, []);

  useEffect(() => {
    if(_.size(pointTriggers) > 0) {
      setLandingOnExplorePointsOn(_.find(pointTriggers, { name: "LOGIN" }) !== undefined ? true : false);
      setOnCompletePointsOn(_.find(pointTriggers, { name: "LEARNING_COMPLETION" }) !== undefined ? true : false);
    }
  }, [pointTriggers]);

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <span className={styles.title}>Points Configuration</span>
        <span className={styles.description}>
        Award reps with points for different learning activities
        </span>
      </div>

      <div className={styles.activities}>
        <div className={styles.activityCard}>
          <span className={styles.title}>On platform visit</span>
          <div className={styles.descriptionContainer}>
            <span className={styles.description}>
            Learners earn points each day they login to heysales
            </span>
            <div className={styles.threshold}>10</div>
            <div className={styles.toggleContainer}>
              <SwitchButton
                id="gamification-activity-points-on"
                checked={landingOnExplorePointsOn}
                handleCheck={handleToggleForExplorePoints}
              />
            </div>
          </div>
        </div>

        <div className={styles.activityCard}>
          <span className={styles.title}>On learning completion</span>
          <div className={styles.descriptionContainer}>
            <span className={styles.description}>
            Learners earn points each time they complete a learning 
            </span>
            <div className={styles.scoreAboveContainer}>
              <div className={styles.threshold}>20</div>
            </div>
            <div className={styles.toggleContainer}>
              <SwitchButton
                id="gamification-activity-points-on-complete"
                checked={onCompletePointsOn}
                handleCheck={handleToggleForOnCompletePoints}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GamificationPointsTab;
